import React from 'react'

import { useSelector } from 'react-redux'

import type { RecipeURN, RecipeUUID } from '@library/menu-service'

import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { DetailContent } from 'routes/Menu/MenuExperience/Detail/DetailContent'
import { useRecipeDetailData } from 'routes/Menu/components/Detail/hooks/useRecipeDetailData'
import { useBasket } from 'routes/Menu/domains/basket'
import {
  getBasketDate,
  getBasketMenuUuid,
  getBasketMenuUrn,
  getBasketRecipeNumPortionsForId,
} from 'selectors/basket'

interface RecipeDetailProps {
  onClose: () => void
  onSelectRecipe?: (recipeId: RecipeUUID, recipeUrn?: RecipeURN) => void
  recipeId: RecipeUUID
  recipeUrn?: RecipeURN
}

export const RecipeDetail = ({
  onClose,
  onSelectRecipe,
  recipeId,
  recipeUrn,
}: RecipeDetailProps) => {
  const deliveryDate = useSelector(getBasketDate)
  const menuId = useSelector(getBasketMenuUuid)
  const menuUrn = useSelector(getBasketMenuUrn)
  const numPortions = useSelector(getBasketRecipeNumPortionsForId(recipeId))
  const menuRecipe = useRecipe(recipeId)
  const { updateRecipePortionsByUuid } = useBasket()

  const handleUpdatePortions = (updatedNumPortions: number) => {
    updateRecipePortionsByUuid(recipeId, updatedNumPortions)
  }

  const { loading, recipe, error, reload } = useRecipeDetailData({
    menuId,
    menuUrn,
    recipeUrn,
    recipeUuid: recipeId,
    numPortions,
    deliveryDate,
  })

  if (!menuRecipe) {
    return null
  }

  return (
    <DetailContent
      uuid={menuRecipe.id}
      title={menuRecipe.name}
      loading={loading}
      error={error}
      recipe={recipe}
      reload={reload}
      onClose={onClose}
      onSelectRecipe={onSelectRecipe}
      numPortions={numPortions}
      onUpdatePortions={handleUpdatePortions}
      flexPortionContext={{ deliveryDate, menuId, menuUrn, recipeId, recipeUrn }}
    />
  )
}
